<template>
    <!-- 工业园平台操作后台头部 -->
    <div class="aheader">
        <div class="left_logo">
            <div class="logo_img">
                <!-- <img src="@/assets/kangshenglogo.png" alt /> -->
                <img src="@/assets/newscreen/logo.png" alt />
            </div>
            <!-- <div class="title">
                <span>工业园环保后台系统</span>
            </div> -->
        </div>
        <div class="menu_right">
            <div class="user_name">
                欢迎#
                <i>{{ user && typeof user == "object" ? user.username : "请登录" }}</i>
            </div>
            <div style="padding-right: 1em;color: #286dff;cursor: pointer" @click="goPickHome">首页</div>
            <Dropdown @on-click="userActive($event)">
                <a href="javascript:void(0)">
                    账号设置
                    <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                    <DropdownItem name="home">首页</DropdownItem>
                    <!-- <DropdownItem name="changePark" v-if="user.userType == 'SUPER_MANAGER' || user.userType == 'SYSTEM_MANAGER'">切换园区</DropdownItem> -->
                    <DropdownItem name="change">切换账号</DropdownItem>
                    <DropdownItem name="quit">退出登录</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    </div>
</template>

<style lang="scss" scope>
    .aheader {
        width: 100%;
        height: 4em;
        overflow: hidden; //#39c5ff-#a5e2ff
        // background: linear-gradient(#027b5a, #03b094); /* 标准的语法 */
        background-image: linear-gradient(180deg, #E7F3FF 0%, #98BAF6 0%, #ECF0F4 100%);
        border-bottom: 1px solid #ccc;
        padding-left: 15px;
        display: flex;
        justify-content: space-between;
        .left_logo {
            width: auto;
            margin-left: 1em;
            height: 100%;
            display: flex;
            .logo_img {
                height: 100%;
                padding: 0.625em 0;
                img {
                    height: 100%;
                }
            }
            .title {
                line-height: 4em;
                padding-left: 0.625em;
                color: #fff;
                span {
                    font-size: 1.5em;
                }
            }
        }
        .menu_right {
            width: auto;
            margin-right: 2em;
            color: #fff;
            display: flex;
            align-items: center;
            .user_name {
                padding-right: 1em;
            }
            a {
                color: #eee;
            }
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                user: {}
            };
        },
        computed: {},
        mounted() {
            this.user = this.$Local.getLocal("user", "object");
        },
        methods: {
            userActive(msg) {
                switch (msg) {
                    case "change": {
                        this.$Local.removeLocal(["user", "role", "bindCompanies"]);
                        this.$router.push("/");
                        break;
                    }
                    case "quit": {
                        this.$api.A_Park.loginOut(null, [null, null]).then(res => {
                            if (res.code == 0) {
                                this.$Local.removeLocal(["user", "role", "bindCompanies"]);
                                this.$router.push("/");
                            }
                        });

                        break;
                    }
                    case "home": {
                        this.$router.push("/home");
                        break;
                    }
                    case "changePark": {
                        this.$router.push("/park");
                        break;
                    }
                }
            },
            // 去园区首页
            goPickHome() {
                this.$router.push("/home");
            }
        }
    };
</script>